
        <siq-background></siq-background>

        <div class="progress">
            <siq-spinner [color]="'#fea621'"></siq-spinner>
            <h2>{{ (bootstrapService.messageText$ | async)[0] }}</h2>
        </div>
    